__turbopack_context__.v({
  "content": "A-Dkdq_content",
  "counter": "A-Dkdq_counter",
  "list": "A-Dkdq_list",
});
